
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon120Notification = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m89.714 54-2.2-.006v.007zm5.832 28.316-1.905 1.1.003.006zm-2.848 5.017v2.2h.006zm-65.396 0-.006 2.2h.006zm-2.848-5.018 1.902 1.107.004-.007zm5.835-28.314h2.2v-.007zm18.669 33.332a2.2 2.2 0 0 0-4.4 0zm26.484 0a2.2 2.2 0 1 0-4.4 0zm-30.32-59.311 1.107 1.901a27.34 27.34 0 0 1 27.546 0l1.107-1.901 1.107-1.9a31.74 31.74 0 0 0-31.975 0zm29.76 0-1.108 1.901c8.523 4.965 13.768 14.143 13.74 24.071l2.2.007 2.2.006c.032-11.489-6.037-22.125-15.925-27.886zm14.832 25.979h-2.2c0 15.23 3.167 24.286 6.127 29.415l1.905-1.1 1.906-1.1c-2.503-4.336-5.538-12.6-5.538-27.215zm5.832 28.315-1.902 1.106c.206.353.208.791.006 1.146l1.914 1.086 1.913 1.086a5.55 5.55 0 0 0-.03-5.53zm.018 3.338-1.913-1.086a1.11 1.11 0 0 1-.958.566l.005 2.2.006 2.2a5.5 5.5 0 0 0 4.773-2.794zm-2.866 1.68v-2.2H27.302v4.4h65.396zm-65.396 0 .005-2.2a1.1 1.1 0 0 1-.958-.566l-1.913 1.086-1.913 1.086a5.5 5.5 0 0 0 4.773 2.794zm-2.866-1.68 1.913-1.086a1.15 1.15 0 0 1 .007-1.146l-1.902-1.107-1.901-1.106a5.55 5.55 0 0 0-.03 5.53zm.018-3.339 1.906 1.1c2.96-5.129 6.13-14.184 6.13-29.415h-4.4c0 14.615-3.037 22.879-5.541 27.215zm5.835-28.314 2.2-.007c-.027-9.928 5.217-19.106 13.74-24.071l-1.108-1.901-1.107-1.9c-9.888 5.76-15.957 16.396-15.925 27.885zm16.469 33.332h-2.2v3.334h4.4v-3.334zm0 3.334h-2.2c0 8.564 6.9 15.533 15.442 15.533v-4.4c-6.084 0-11.042-4.97-11.042-11.133zM60 104v2.2c8.543 0 15.442-6.969 15.442-15.533h-4.4c0 6.163-4.958 11.133-11.042 11.133zm13.242-13.333h2.2v-3.334h-4.4v3.334z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M84.185 14.147a2.2 2.2 0 0 0-2.37 3.707L83 16zm12.837 20.816a2.2 2.2 0 0 0 3.956-1.926L99 34zm-78-1.926a2.2 2.2 0 1 0 3.956 1.926L21 34zm19.163-15.183a2.2 2.2 0 0 0-2.37-3.707L37 16zM83 16l-1.185 1.854a42.26 42.26 0 0 1 15.207 17.11L99 34l1.978-.963a46.66 46.66 0 0 0-16.793-18.89zM21 34l1.978.963a42.26 42.26 0 0 1 15.207-17.11L37 16l-1.185-1.854a46.66 46.66 0 0 0-16.793 18.89z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\"><path d=\"m89.714 54-2.2-.006v.007zm5.832 28.316-1.905 1.1.003.006zm-2.848 5.017v2.2h.006zm-65.396 0-.006 2.2h.006zm-2.848-5.018 1.902 1.107.004-.007zm5.835-28.314h2.2v-.007zm18.669 33.332a2.2 2.2 0 0 0-4.4 0zm26.484 0a2.2 2.2 0 1 0-4.4 0zm-30.32-59.311 1.107 1.901a27.34 27.34 0 0 1 27.546 0l1.107-1.901 1.107-1.9a31.74 31.74 0 0 0-31.975 0zm29.76 0-1.108 1.901c8.523 4.965 13.768 14.143 13.74 24.071l2.2.007 2.2.006c.032-11.489-6.037-22.125-15.925-27.886zm14.832 25.979h-2.2c0 15.23 3.167 24.286 6.127 29.415l1.905-1.1 1.906-1.1c-2.503-4.336-5.538-12.6-5.538-27.215zm5.832 28.315-1.902 1.106c.206.353.208.791.006 1.146l1.914 1.086 1.913 1.086a5.55 5.55 0 0 0-.03-5.53zm.018 3.338-1.913-1.086a1.11 1.11 0 0 1-.958.566l.005 2.2.006 2.2a5.5 5.5 0 0 0 4.773-2.794zm-2.866 1.68v-2.2H27.302v4.4h65.396zm-65.396 0 .005-2.2a1.1 1.1 0 0 1-.958-.566l-1.913 1.086-1.913 1.086a5.5 5.5 0 0 0 4.773 2.794zm-2.866-1.68 1.913-1.086a1.15 1.15 0 0 1 .007-1.146l-1.902-1.107-1.901-1.106a5.55 5.55 0 0 0-.03 5.53zm.018-3.339 1.906 1.1c2.96-5.129 6.13-14.184 6.13-29.415h-4.4c0 14.615-3.037 22.879-5.541 27.215zm5.835-28.314 2.2-.007c-.027-9.928 5.217-19.106 13.74-24.071l-1.108-1.901-1.107-1.9c-9.888 5.76-15.957 16.396-15.925 27.885zm16.469 33.332h-2.2v3.334h4.4v-3.334zm0 3.334h-2.2c0 8.564 6.9 15.533 15.442 15.533v-4.4c-6.084 0-11.042-4.97-11.042-11.133zM60 104v2.2c8.543 0 15.442-6.969 15.442-15.533h-4.4c0 6.163-4.958 11.133-11.042 11.133zm13.242-13.333h2.2v-3.334h-4.4v3.334z\" fill=\"#000\"/><path d=\"M84.185 14.147a2.2 2.2 0 0 0-2.37 3.707L83 16zm12.837 20.816a2.2 2.2 0 0 0 3.956-1.926L99 34zm-78-1.926a2.2 2.2 0 1 0 3.956 1.926L21 34zm19.163-15.183a2.2 2.2 0 0 0-2.37-3.707L37 16zM83 16l-1.185 1.854a42.26 42.26 0 0 1 15.207 17.11L99 34l1.978-.963a46.66 46.66 0 0 0-16.793-18.89zM21 34l1.978.963a42.26 42.26 0 0 1 15.207-17.11L37 16l-1.185-1.854a46.66 46.66 0 0 0-16.793 18.89z\" fill=\"var(--theme-primary, #810ea9)\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-120-notification.ff633baa008ee3d00a5d99502f4b039c.svg"),
        {
          React: SvgIcon120Notification,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      